/** @jsx jsx */

import React, {
  Fragment as _,
  useState,
  useContext,
  useMemo,
  useRef,
  useEffect,
} from 'react';
import { css, jsx } from '@emotion/core';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { colors, getButtonFocus } from 'styles/variables';
import { interactionContext } from './interactionContext';
import Option from './Option';
import getBlocksByType from 'services/apiHelpers/getBlocksByType';
import Feedback from 'components/lib/Feedback';
import { setScore, getScore } from 'services/scoring';
import { unlockInteraction } from 'services/unlockInteraction';
import { findByKeyVal_V2 } from 'services/findByKeyVal';
import renderBlock from 'services/apiHelpers/renderBlock';
import EditableBtn from 'components/lib/EditableBtn';
// import {
//   getCMIInteractionsId,
//   setCMIInteractionsSortation,
// } from 'services/scorm/scormService';
import getAllInteractions from 'services/apiHelpers/getAllInteractionsOfType';
import getBlockById from 'services/apiHelpers/getBlockById';
import { useDispatch } from 'react-redux';
import { updateScoreAction, addScormResponseAction } from 'store/next';

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;
const sessionLock = {};

const Sortation = props => {
  // break all this up maybe
  // MEMOIZE ALL THE THINGS !!!

  const context = useContext(interactionContext);
  const {
    baseColor = lGrey2,
    numberOfAttempts,
    score,
    showCorrectAnswer,
    showAttemptNumber,
    useMediaInFeedback = true,
    useFeedback = true,
  } = context.props;
  const { id, children } = props;
  const answers = getBlocksByType('Answer', 'id');
  const heading0 = getBlocksByType('SortationHeading0', 'id');
  const heading1 = getBlocksByType('SortationHeading1', 'id');
  const options = children
    .filter(c => answers.includes(c.props.id))
    .map((c, i) => {
      const { id, children } = c.props;
      return { id, children };
    });
  const sortFrom = children.find(c => heading0.includes(c.props.id));
  const sortTo = children.find(c => heading1.includes(c.props.id));
  const shuffle = arr => [...arr].sort(() => Math.random() - Math.random());
  const shuffledOptions = useMemo(() => shuffle(options), []);
  const [order, setOrder] = useState(() =>
    !window.dev() ? shuffledOptions : options
  );
  const [isLive, setIsLive] = useState(false);
  const [submit, setSubmit] = useState(sessionLock[context.id] ? 2 : 0);

  const sortation = useRef(null);
  const allSortationInteractions = useRef(null);
  const hasAttempt = useRef(false);
  const attempt = useRef(0);
  const isCorrect = useRef(false);

  sessionLock[context.id] = score && getScore(context.id) !== undefined;

  const [feedback, setFeedback] = useState(false);

  const dispatch = useDispatch();

  const updateOrder = $ => {
    const { source, destination } = $;

    const reorder = (list, startIndex, endIndex) => {
      const reordered = [...list];
      const [removed] = reordered.splice(startIndex, 1);
      reordered.splice(endIndex, 0, removed);

      return reordered;
    };

    const newOrder = reorder(order, source.index, destination.index);

    isCorrect.current = options.every((o, i) => o.id === newOrder[i].id);

    // updating setScore for old ways ( display results )
    setScore(context.id, isCorrect.current);
    //
    //

    setOrder(newOrder);
  };

  const showFeedback = correct => {
    useFeedback && setFeedback(true);

    if (window.dev()) {
      return;
    }

    const sortationResolved = correct || attempt.current === numberOfAttempts;

    if (sortationResolved && showCorrectAnswer === 1) {
      setOrder(options);
    }

    if (sortationResolved && score) {
      const alphabetized = Array.from(
        sortation.current.querySelectorAll('.sortation-option')
      ).map((option: any) => {
        const id = option.id.replace('sortation-option-', '');
        return 'abcdefghijklmnopqrstuvwxyz'.split('')[
          options.findIndex((o: any) => o.id === id)
        ];
      });

      dispatch(updateScoreAction(context.id, correct));
      dispatch(
        addScormResponseAction({
          id: context.id,
          reportable: 'multichoice',
          type: 'sequencing',
          response: isLive ? alphabetized.join(',') : 'neutral',
          // @sam. updated this from the bool it was. to send a 1 | 0
          result: isCorrect.current ? 1 : 0,
        })
      );
    }

    if (isCorrect.current || attempt.current === numberOfAttempts) {
      setSubmit(2);
      unlockInteraction(context.id);
    }
  };

  const onClose = () => {
    // const unlock = isCorrect.current || attempt.current === numberOfAttempts;

    // !window.dev() && unlock && setSubmit(2);
    setFeedback(false);
    //
    // unlock && unlockInteraction(context.id);
    //
  };

  useEffect(() => {
    if (hasAttempt.current && !isLive) {
      setIsLive(true);
    }

    if (parent.showFeedback) {
      parent.showFeedback[context.id] = correct => {
        if (feedback) {
          setFeedback(false);
          requestAnimationFrame(() =>
            showFeedback((isCorrect.current = correct))
          );
          //
        } else {
          showFeedback((isCorrect.current = correct));
        }
      };
    }

    if (order.length !== options.length) {
      setOrder(options);
    }
  });

  const SubmitBtn: any = renderBlock(
    findByKeyVal_V2(props.id, 'type', 'EditableButton'),
    {
      EditableButton: ({ ...props }) => (
        <EditableBtn
          {...{ enabled: !!isLive, ...props }}
          onClick={() => {
            attempt.current += 1;
            showFeedback(isCorrect.current);
          }}
        />
      ),
    }
  );

  useEffect(() => {
    if (window.dev() || !sortation.current) {
      return;
    }

    const alphabetized = Array.from(
      sortation.current.querySelectorAll('.sortation-option')
    ).map((option: any) => {
      const id = option.id.replace('sortation-option-', '');
      return 'abcdefghijklmnopqrstuvwxyz'.split('')[
        options.findIndex((o: any) => o.id === id)
      ];
    });

    // const data = {
    //   id: getCMIInteractionsId(context.id),
    //   type: 'sequencing',
    //   response: isLive ? alphabetized.join(',') : 'neutral',
    //   result: isCorrect.current,
    // };

    // setCMIInteractionsSortation(data);
  });

  let parsedIsCorrect;
  if (attempt.current < numberOfAttempts) {
    parsedIsCorrect = isCorrect.current || 'attempt';
  } else {
    parsedIsCorrect = isCorrect.current;
  }

  return (
    <_>
      <div
        ref={sortation}
        css={css`
          position: relative;
          width: 100%;
          padding: 10px 10px;
          border-radius: 10px;
          background: ${baseColor};
          pointer-events: ${submit === 0 ? 'auto' : 'none'};
        `}
      >
        {sortFrom}
        <DragDropContext
          onDragEnd={data => {
            if (!data.destination) {
              return;
            }

            updateOrder(data);
          }}
        >
          <Droppable droppableId={`Sortation_${id}`} type="droppableSortation">
            {provided => (
              <div ref={provided.innerRef}>
                {order.map((option, i) => (
                  <Draggable key={option.id} draggableId={option.id} index={i}>
                    {(provided, snapshot) => {
                      if (!hasAttempt.current && snapshot.isDragging)
                        hasAttempt.current = true;
                      return (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          css={css`
                            border-radius: 5px;
                            ${!snapshot.isDragging &&
                              `&:focus {
                              //
                              ${getButtonFocus(
                                context.props.panelBackground || lPink
                              )}
                            }`}
                          `}
                          style={{
                            ...provided.draggableProps.style,
                          }}
                        >
                          <Option
                            key={option.id}
                            option={option}
                            isDragging={snapshot.isDragging}
                          />
                        </div>
                      );
                    }}
                  </Draggable>
                ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
        {sortTo}
      </div>

      {/* 
      
      opacity: ${isLive && submit === 0 ? 1 : submit > 0 ? 0.2 : 0}; 
      
      */}

      <div
        css={css`
          margin-top: 20px;
          ${!window.dev() &&
            `
            opacity: ${isLive && submit === 0 ? 1 : 0};
            pointer-events: ${isLive && submit === 0 ? 'auto' : 'none'};
            transition: opacity 0.2s;
          `}
        `}
      >
        {SubmitBtn}
      </div>

      {feedback && (
        <Feedback
          id={context.id}
          // correct={isCorrect.current}
          correct={window.dev() ? isCorrect.current : parsedIsCorrect}
          attempt={attempt.current}
          numberOfAttempts={numberOfAttempts}
          showAttemptNumber={showAttemptNumber}
          showCorrectAnswer={showCorrectAnswer}
          useMediaInFeedback={useMediaInFeedback}
          onClose={() => {
            const tick = setInterval(() => {
              const submitButtonElement: any = document.querySelector(
                `#i${SubmitBtn?.props?.id}`
              );

              if (submitButtonElement) {
                submitButtonElement.focus();

                clearInterval(tick);
              }
            }, 0);

            onClose();
          }}
        />
      )}
    </_>
  );
};

export default Sortation;
